import { useContext, useEffect, useState } from 'react'
import { useRouter } from 'next/navigation'
import { usePathname } from 'next/navigation'
import { useCurrentLocale } from 'src/i18n/client/useCurrentLocale'
import { useTranslateEntry } from 'src/i18n/client/useTranslateEntry'
import { getLangChangerOptions } from 'src/i18n/client/getLangChangerOptions'
import { getInterfaceLocale } from 'src/i18n/config'
import { GlobalContext } from 'src/components/layout/GlobalContext'

const COOKIE_SWITCHER_LOCALES = ['pl', 'en']

export const LangChanger = () => {
  const locale = useCurrentLocale()
  const interfaceLocale = getInterfaceLocale(locale)
  const translateEntry = useTranslateEntry()
  const { langChangerState } = useContext(GlobalContext)

  const router = useRouter()
  const pathname = usePathname()
  const [options, setOptions] = useState([])

  useEffect(() => {
    setOptions(
      getLangChangerOptions(langChangerState, locale).filter((option) =>
        COOKIE_SWITCHER_LOCALES.includes(option.locale),
      ),
    )
  }, [langChangerState, locale, pathname])

  const handleChange = (path) => {
    router.push(path, { shallow: true })
  }

  return (
    <div className="flex justify-end items-center gap-x-13 pb-12">
      {COOKIE_SWITCHER_LOCALES.map((itemLocale) => {
        const option = options.find((entry) => entry.locale === itemLocale) || null
        const isCurrent = itemLocale === interfaceLocale

        return (
          <button
            key={itemLocale}
            type="button"
            aria-label={translateEntry('T_LANG_CHANGER')}
            disabled={isCurrent}
            className={`font-sans text-buttons-l font-medium leading-100 text-dark-blue-dark-blue7 relative min-w-[22px] h-[21px] flex justify-center items-center before:content-[''] before:w-0 before:h-1 before:block before:bg-current before:absolute before:bottom-0 before:left-0 before:transition-all ${isCurrent ? 'before:w-full' : ''}`}
            onClick={!isCurrent && option ? () => handleChange(option.path) : null}
          >
            {itemLocale.toUpperCase()}
          </button>
        )
      })}
    </div>
  )
}
